import { graphHooks } from '@tunasong/graph-lib/react'
import { Close } from '@tunasong/icons'
import type { FC } from 'react'
import { UserAvatar } from './user-avatar.js'
import {
  IconButton,
  LinearProgress,
  ListItemText,
  List,
  ListItem,
  ListItemAvatar,
  Checkbox,
} from '../primitives/index.js'

export interface UserListProps {
  userIds: string[]
  checked?: string[]
  size?: 'tiny' | 'small' | 'medium' | 'large'
  onChange?(userIds: string[]): void
  onRemove?(userId: string): void
}

export const UserList: FC<UserListProps> = props => {
  const { size = 'small', userIds: users = [], checked = [], onChange, onRemove } = props

  const { profiles, isLoading } = graphHooks.useProfiles({ userIds: users, includeAssistant: false })

  const handleToggle = (value: string) => () => {
    const currentIndex = checked.indexOf(value)
    const newChecked = [...checked]

    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }
    if (onChange) {
      onChange(newChecked)
    }
  }

  return isLoading ? (
    <LinearProgress />
  ) : (
    <List>
      {profiles?.map(profile => (
        <ListItem
          key={profile.userId}
          secondaryAction={
            <>
              {onChange ? (
                <Checkbox onChange={handleToggle(profile.userId)} checked={checked.indexOf(profile.userId) !== -1} />
              ) : null}
              {onRemove ? (
                <IconButton onClick={() => onRemove(profile.userId)}>
                  <Close />
                </IconButton>
              ) : null}
            </>
          }
          disablePadding
        >
          <ListItemAvatar>
            <UserAvatar size={size} userId={profile.userId} />
          </ListItemAvatar>
          <ListItemText primary={profile.name ? profile.name : profile.email} secondary={profile.email} />
        </ListItem>
      ))}
    </List>
  )
}
